import React, { useState } from 'react';
import { Button, Col, Form, Modal, Row } from 'react-bootstrap';

// Lets an admin choose which machines of one category the Floor Deck counts.
// Mount it only while open, so each opening starts from the current choices.
function CategoryMachinesModal({ category, machines, excludedMachines, onApply, onClose }) {
    const names = machines.map((machine) => machine.machine);
    const [ticked, setTicked] = useState(() => names.filter((name) => !excludedMachines.includes(name)));

    const toggle = (name) => setTicked((current) => (
        current.includes(name) ? current.filter((entry) => entry !== name) : [...current, name]
    ));

    return (
        <Modal show onHide={onClose} size="lg" aria-labelledby="category-machines-title">
            <Modal.Header closeButton>
                <Modal.Title id="category-machines-title">{category} machines</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p className="text-muted small">
                    Tick the machines the Floor Deck Utilization should count. New machines added to this category are counted automatically.
                </p>
                <div className="d-flex gap-3 mb-2">
                    <Button variant="link" size="sm" className="p-0" onClick={() => setTicked(names)}>Select all</Button>
                    <Button variant="link" size="sm" className="p-0" onClick={() => setTicked([])}>Clear all</Button>
                </div>
                <Row>
                    {machines.map((machine, index) => (
                        <Col key={machine.machine} xs={12} sm={6} md={4} className="mb-2">
                            <Form.Check
                                type="checkbox"
                                id={`category-machine-${index}`}
                                label={machine.active === false ? `${machine.machine} (inactive)` : machine.machine}
                                checked={ticked.includes(machine.machine)}
                                onChange={() => toggle(machine.machine)}
                            />
                        </Col>
                    ))}
                </Row>
                <p className="text-muted small mt-2 mb-0" role="status">
                    {ticked.length === 0
                        ? 'Tick at least one machine. To leave out the whole category, untick the category instead.'
                        : `${ticked.length} of ${names.length} machines counted.`}
                </p>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onClose}>Cancel</Button>
                <Button variant="primary" onClick={() => onApply(ticked)} disabled={ticked.length === 0}>Apply</Button>
            </Modal.Footer>
        </Modal>
    );
}

export { CategoryMachinesModal };
